<div class='container d-flex'>
  <div class='col w-60 justify-content-center'>

    <div class="card" style='margin-top: 25px'>
      <div class='card-header'>
        <h5 class="card-title">Login</h5>
      </div>

      <div class="card-body">
        <div class='col w-60'>
          <form [formGroup]="loginForm" (ngSubmit)="submitCredentials()">
            <div class='col'>
              <div class='col form-group'>
                <label for="Username">Benutzername*</label>
                <input class='form-control' formControlName="Username" id="Username" required="true">
                <small class='text-danger' *ngIf="loginForm.controls.Username.errors">
                  <p *ngFor="let error of loginForm.controls.Username.errors | keyvalue">
                    <span *ngIf="error.key === 'required' && loginForm.controls.Username.touched; else errorResponse">
                      Das Feld darf nicht leer sein.
                    </span>
                    <ng-template #errorResponse>
                      <span *ngIf="error.key !== 'required'">{{error.value}}</span>
                    </ng-template>
                  </p>
                </small>
              </div>

              <div class='col form-group'>
                <label for="Password">Passwort*</label>
                <input class='form-control' type='password' formControlName="Password" id="Password" required="true">
                <small class='text-danger' *ngIf="loginForm.controls.Password.errors">
                  <p *ngFor="let error of loginForm.controls.Password.errors | keyvalue">
                    <span *ngIf="error.key === 'required' && loginForm.controls.Password.touched; else errorResponse">
                      Das Feld darf nicht leer sein.
                    </span>
                    <ng-template #errorResponse>
                      <span *ngIf="error.key !== 'required'">{{error.value}}</span>
                    </ng-template>
                  </p>
                </small>
              </div>
            </div>

            <div class='col'>
              <button class='btn btn-success ml-auto' type="submit" [disabled]="loginForm.pristine">Login</button>
              <button class='btn btn-default mr-auto' type="reset" (click)="resetForm()"
                      [disabled]="loginForm.pristine">Zurücksetzen
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>

  </div>
</div>
